"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfWebsiteProperty = instanceOfWebsiteProperty;
exports.WebsitePropertyFromJSON = WebsitePropertyFromJSON;
exports.WebsitePropertyFromJSONTyped = WebsitePropertyFromJSONTyped;
exports.WebsitePropertyToJSON = WebsitePropertyToJSON;
exports.WebsitePropertyToJSONTyped = WebsitePropertyToJSONTyped;
/**
 * Check if a given object implements the WebsiteProperty interface.
 */
function instanceOfWebsiteProperty(value) {
    if (!('key' in value) || value['key'] === undefined)
        return false;
    if (!('value' in value) || value['value'] === undefined)
        return false;
    return true;
}
function WebsitePropertyFromJSON(json) {
    return WebsitePropertyFromJSONTyped(json, false);
}
function WebsitePropertyFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'key': json['key'],
        'value': json['value'],
    };
}
function WebsitePropertyToJSON(json) {
    return WebsitePropertyToJSONTyped(json, false);
}
function WebsitePropertyToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'value': value['value'],
    };
}
//# sourceMappingURL=websiteProperty.js.map